import axios from "axios";
import {
    TRANSPORT_MANUFACTURERS,
    TRANSPORT_FUEL,
    TRANSPORT_BURNING_RATES,
    TRANSPORT_ADDED,
    TRANSPORT_BODY_TYPES,
    TRANSPORT_BODY_TYPES_ADDITIONALS,
    VARIANT_TYPES,
    TRANSPORT_LOADING_TYPES_ADDITIONALS,
    ADR,
    UTILS,
    TRANSPORT_MANUFACTURE_YEARS,
    PATRIAL_LOAD,
    ROUTE_FROM,
    ROUTE_TO,
    TRANSPORT,
    LOADING_TYPES,
} from "../../endpointsConst";

const TransportDropdownService = {};

TransportDropdownService.getBodyTypes = (lang) =>
    axios.get(UTILS + TRANSPORT_BODY_TYPES + `?lang=${lang}`);

TransportDropdownService.getBodyTypesAdditional = (lang) =>
    axios.get(UTILS + TRANSPORT_BODY_TYPES_ADDITIONALS + `?lang=${lang}`);

TransportDropdownService.getVariantTypes = (lang) =>
    axios.get(UTILS + VARIANT_TYPES + `?lang=${lang}`);

TransportDropdownService.getLoadingTypes = (lang) =>
    axios.get(UTILS + LOADING_TYPES + `?lang=${lang}`);

TransportDropdownService.getLoadingTypesAdditional = (lang) =>
    axios.get(UTILS + TRANSPORT_LOADING_TYPES_ADDITIONALS + `?lang=${lang}`);

TransportDropdownService.getManufactures = (lang) =>
    axios.get(UTILS + TRANSPORT_MANUFACTURERS + `?lang=${lang}`);

TransportDropdownService.getManufacturesYears = (lang) =>
    axios.get(UTILS + TRANSPORT_MANUFACTURE_YEARS + `?lang=${lang}`);

TransportDropdownService.getFuel = (lang) =>
    axios.get(UTILS + TRANSPORT_FUEL + `?lang=${lang}`);

TransportDropdownService.getBurningRates = (lang) =>
    axios.get(UTILS + TRANSPORT_BURNING_RATES + `?lang=${lang}`);

TransportDropdownService.getAdr = (lang) => axios.get(UTILS + ADR + `?lang=${lang}`);

TransportDropdownService.getAdded = (lang) =>
    axios.get(UTILS + TRANSPORT_ADDED + `?lang=${lang}`);

TransportDropdownService.getPatrialLoad = (lang) =>
    axios.get(UTILS + PATRIAL_LOAD + `?lang=${lang}`);

TransportDropdownService.getRoutesTo = (lang) =>
    axios.get(TRANSPORT + UTILS + ROUTE_TO + `?lang=${lang}`);

TransportDropdownService.getRoutesFrom = (lang) =>
    axios.get(TRANSPORT + UTILS + ROUTE_FROM + `?lang=${lang}`);

export { TransportDropdownService };
